import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_API_URL } from '../constant';
import { Spinner } from 'react-bootstrap';
function formatDateToDDMMYYYY(timestamp) {
    var date = new Date(timestamp);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
}

function formatAMPM(datetime) {
    var timestamp = new Date(datetime);
    var hours = timestamp.getHours();
    var minutes = timestamp.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}

function UserPredictionHistory() {

    const [data, setData] = useState([]);
    // const [isData, setIsData] = useState(false);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        const token = localStorage.getItem('token');

        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        const fetchUsersHistory = async () => {
            try {
                setLoading(true);

                const result = await axios.get(`${BASE_API_URL}api/winning/user/user_history`, config);
                result.data.sort((a, b) => {
                    return new Date(b.transaction_date) - new Date(a.transaction_date);
                });
                // if (result.data.length > 0) {
                //     setIsData(true);
                // }
                setData(result.data);
                setLoading(false);
            }
            catch (error) {
                setLoading(false);
                console.error(error.message);
            }
        }
        fetchUsersHistory();
    }, []);

    return (
        <div className='text-center'>
            <h1>Your Prediction History</h1>
            <hr />
            {loading ?
                <div
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%,-50%)",
                    }}
                >
                    <Spinner animation="border" />
                </div>
                : data.length === 0 ? (
                    <div>
                        <h3>You have not made any prediction yet.</h3>
                        <h3>
                            Go to <a href="/user/prediction-number">Prediction</a> to make a prediction.
                        </h3>
                    </div>
                )
                    : (
                        <div>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Date | Time</th>
                                        <th>Prediction Number</th>
                                        <th>Winning Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item) => (
                                        <tr key={item._id}>
                                            <td>{formatDateToDDMMYYYY(item.transaction_date) + " " + formatAMPM(item.transaction_date)}</td>
                                            <td>{item.prediction_number}</td>
                                            <td>{item.winning_number === undefined ? <strong> Yet to be announced</strong> : <span className='text-success'>{item.winning_number}</span>}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )
            }
        </div>
    );
};

export default UserPredictionHistory;
